


 $(document).ready(function(){
   
   $("#col-digital").click(function(){
//do something
  Swal.fire({
    title: '',
    width: 1000,
    html:
      '<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdg8N1OZ5RCf0U0c74P-2w9Z2PGUI_aJxcaYRXcHX47fgGNSA/viewform?embedded=true" style="width:100%;height:600px" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>',
  })
});

$("#col-physical").click(function(){
//do something
  Swal.fire({
    title: '',
    width: 1000,
    html:
      '<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeHcycZWBb3JPByN2xW8Cj8M3avLOsnoUlPwmys0UpS0EM9Vw/viewform?embedded=true" style="width:100%;height:600px" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>',
  })
});

$("#col-pdf").click(function(){
//do something
  Swal.fire({
    title: '',
    width: 1000,
    html:
      '<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfDL4K6ek55u38ZbfzKr6OmneNJtHze6dOO7-ln8zPf6f5oVw/viewform?embedded=true" style="width:100%;height:600px" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>',
  })
});
   
   
$(".main-menu ul>li").hover(function(){
$(this).find("ul.col-navlist").hide();
  
  });
});
  



$(document).ready(function(){
  
$(".main-menu > ul > li.product-item--vertical a").click(function(e){
    e.preventDefault();
  $(this).parent().find("h3.product-item__title.text--strong.link img").toggleClass("rotate");
$(this).parent().find("ul.col-navlist:nth-child(2)").toggleClass("togleclass");
event.stopPropagation();
returns:false;  
});
  
  
  $(".has-children a").click(function(e){
    e.preventDefault();
  $(this).parent().find("ul.col-navlist").toggleClass("togleclass");
  
  
  });

      $('td.text-center span').click(function(event) {
     event.preventDefault(); // This prevents the default link behavior
    event.stopPropagation();


      var href = $(this).data('href');
      var hrefParts = href.split('/');
      var lastPart = hrefParts[hrefParts.length - 1];
      var idParts = lastPart.split(':');
      var id = idParts[0];
      $(this).text("added...");
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: id
        },
        dataType: 'json',
        success: function(response) {

          document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: response,
            addToCartBtn: "add to cart"
          }
        }));
          $("a#HeaderCartTrigger").click();
        }
      });
    });
  
});




document.addEventListener("DOMContentLoaded", function() {
  const currentUrl = window.location.pathname.replace(/\/$/, ''); // remove trailing slash
  const menuLinks = document.querySelectorAll(".collapsible-content__inner a.submenu-first");

  menuLinks.forEach(link => {
    // normalize link path (remove domain, trailing slash)
    let linkHref = link.getAttribute("href") || '';
    linkHref = linkHref.replace(window.location.origin, '').replace(/\/$/, '');

    if (linkHref === currentUrl) {
      
      // Replace 🔷 with 🔺 or any other red symbol
      link.innerHTML = link.innerHTML.replace('🔷', '');

      // Optional styling for emphasis
      link.style.color = "#c62828"; // dark red
      link.style.fontWeight = "600";
      link.classList.add("active-menu-item");
    }
  });
});

// document.getElementById("stop_link").addEventListener("click", function(event){
//   event.preventDefault()
// });

document.addEventListener('DOMContentLoaded', function () {

    // --- 1. Get current URL handle ---
    let currentPath = window.location.pathname.toLowerCase();
    let currentHandle = '';

    // Extract the handle from the URL (e.g., 'airway-management-1')
    let pathSegments = currentPath.split('/').filter(Boolean);
    if (pathSegments.length > 0) {
        currentHandle = pathSegments[pathSegments.length - 1].split('?')[0].split('#')[0];
    }
    
    // Define a function to 'slugify' text (convert "Airway Management" to "airway-management")
    const slugify = (text) => {
        return text.toLowerCase()
                   .trim()
                   .replace(/[^\w\s-]/g, '') // Remove all non-word characters (like 🔷)
                   .replace(/[\s_-]+/g, '-') // Replace spaces and underscores with a single dash
                   .replace(/^-+|-+$/g, ''); // Remove leading/trailing dashes
    };

    // --- 2. Select Menu Button Elements ---
    // Targeting all the collapsible menu headings
    const menuButtons = document.querySelectorAll('button.collapsible-trigger-btn'); 

    // --- 3. Iterate and Match ---
    menuButtons.forEach(buttonElement => {
        // The menu name is inside the first <span> child of the button
        const textSpan = buttonElement.querySelector('.collapsible-trigger__layout > span:first-child');
        
        if (!textSpan) return; // Skip if the expected span structure isn't found
        
        let headingText = textSpan.textContent.trim();
        
        // Remove '🔴' and '🔷' before slugifying to get a clean handle
        let cleanText = headingText.replace('🔴', '').replace('🔷', '').trim();

        // Create a comparable slug from the heading text
        // E.g., "Airway Management" becomes "airway-management"
        let headingSlug = slugify(cleanText);

        // Check if the current page handle matches or starts with the heading slug 
        // (to cover cases like 'airway-management' vs 'airway-management-1').
        const isMatch = currentHandle === headingSlug || currentHandle.startsWith(headingSlug + '-');


        if (isMatch) {
            
            // --- ACTION: Add 🔴 to the Menu Heading Text Span ---
            // Prepend 🔴 only if it hasn't been added already
            if (!textSpan.textContent.trim().startsWith('🔴')) {
                // Ensure we only modify the text content of the inner span
                textSpan.textContent = '🔴 ' + cleanText;
            }

            // Optional: Apply styling directly to the span for color
            // textSpan.style.color = "#c62828";
            textSpan.style.fontWeight = "600";
        }
    });

    // --- 4. RETAIN LOGIC FOR SUB-MENU ITEMS (A-tags) ---
    // This logic ensures the links inside the menu are also marked if you go to them
    const menuLinks = document.querySelectorAll('.collapsible-content__inner a');
    menuLinks.forEach(link => {
        let linkHref = link.getAttribute('href') || '';
        let linkPath = linkHref.split('?')[0].split('#')[0].replace(window.location.origin, '').toLowerCase().replace(/\/$/, '');
        
        // Match the full path for sub-links
        if (linkPath === currentPath.replace(/\/$/, '')) {
            let currentText = link.textContent.trim();
            currentText = currentText.replace('🔷', '').trim();
            if (!currentText.startsWith('🔴')) {
                link.textContent = '🔴 ' + currentText;
            }
            link.style.color = "#c62828";
            link.style.fontWeight = "600";
        }
    });
});